import { Flex } from "antd";
import { styled } from "styled-components";

export const StyledLayout = styled.div<{ personalFlow?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-height: ${({ personalFlow }) => (personalFlow ? "auto" : "100vh")};
  background: ${({ personalFlow }) => (personalFlow ? "#fff" : "transparent")};
`;

export const Footer = styled.footer<{ mainColor: string }>`
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: ${({ mainColor }) => mainColor};

  a {
    color: ${({ mainColor }) => mainColor};
    text-decoration: none;
    transition: text-decoration 0.3s;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Header = styled.header<{ mainColor?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 20px 10px;
  background-color: ${({ mainColor }) => mainColor};
  color: white;
  font-weight: bold;
  font-family: "Lato", sans-serif;
  position: relative !important;
  z-index: 9;
`;

export const LangSwitcher = styled(Flex)`
  div {
    height: 15px;
    width: 2px;
    background: #000000;
  }
`;
